import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { useMsal, useAccount } from '@azure/msal-react';
import { UserCircleIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import { isAuthConfigured } from '../../config/authConfig';

export function UserMenu() {
  // Si no está configurada la autenticación, no mostrar nada
  if (!isAuthConfigured()) {
    return null;
  }

  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
  };

  if (!account) {
    return null;
  }

  // Obtener iniciales del nombre
  const getInitials = (name: string | undefined): string => {
    if (!name) return '?';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  return (
    <Menu as="div" className="relative">
      <Menu.Button className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-honne-light transition-colors">
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-honne-navy to-honne-blue flex items-center justify-center text-white text-sm font-medium">
          {getInitials(account.name)}
        </div>
        <div className="hidden md:block text-left">
          <p className="text-sm font-medium text-honne-navy truncate max-w-[150px]">
            {account.name}
          </p>
          <p className="text-xs text-gray-500 truncate max-w-[150px]">
            {account.username}
          </p>
        </div>
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right rounded-xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
          <div className="p-2">
            {/* User Info */}
            <div className="px-3 py-2 border-b border-gray-100 mb-2">
              <p className="text-sm font-medium text-honne-navy">{account.name}</p>
              <p className="text-xs text-gray-500">{account.username}</p>
            </div>

            {/* Profile Option */}
            <Menu.Item>
              {({ active }) => (
                <button
                  className={`${
                    active ? 'bg-honne-light' : ''
                  } group flex w-full items-center rounded-lg px-3 py-2 text-sm text-gray-700`}
                  disabled
                >
                  <UserCircleIcon className="mr-3 h-5 w-5 text-gray-400" />
                  Mi Perfil
                  <span className="ml-auto text-xs text-gray-400">Próximamente</span>
                </button>
              )}
            </Menu.Item>

            {/* Logout */}
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={handleLogout}
                  className={`${
                    active ? 'bg-red-50 text-red-600' : 'text-gray-700'
                  } group flex w-full items-center rounded-lg px-3 py-2 text-sm`}
                >
                  <ArrowRightOnRectangleIcon className="mr-3 h-5 w-5" />
                  Cerrar Sesión
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
